import { render } from "./IconWhatsApp.vue?vue&type=template&id=3a11c0d2&scoped=true&ts=true"
import script from "./IconWhatsApp.vue?vue&type=script&lang=ts"
export * from "./IconWhatsApp.vue?vue&type=script&lang=ts"

import "./IconWhatsApp.vue?vue&type=style&index=0&id=3a11c0d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a11c0d2"]])

export default __exports__